export default __webpack_public_path__ + "static/media/logo.f4e0ac84.png";